import { computed, reactive } from "vue";
import { booleanHook } from "@/common/hooks/booleanHook.js";
import { adminApi, authApi } from "../api";

const isLoading = booleanHook();
const userProfile = reactive({});

export default function () {
  const loadUserProfile = async () => {
    isLoading.setTrue();
    try {
      const res = await adminApi.getUserProfile();
      Object.assign(userProfile, { ...res.data });
      return res.data;
    } catch (e) {
      console.log(e);
    } finally {
      isLoading.setFalse();
    }
  };

  const changePassword = async (payload) => {
    try {
      const res = await authApi.changePassword(payload);
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };

  const changeEmail = async (payload) => {
    try {
      const res = await authApi.changeEmail(payload);
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };

  return {
    isLoading: computed(() => isLoading.flag.value),
    userProfile: computed(() => userProfile),
    loadUserProfile,
    changePassword,
    changeEmail,
  };
}
